import DashboardHeading from "components/Dashboard/DashboardHeading";
import React from "react";
import DriverProfileOverview from "components/DriverProfileComponent/DriverProfileOverview";
import { useGetDriverDashboardStatsQuery } from "store/services/driverDashboardApi";


export const DriverDashboardScreen = () => {
  const {
    data: fetchStatsData,
    isLoading: statsDataLoading,
    isFetching: fetchingDashboard,
  } = useGetDriverDashboardStatsQuery();

  return (
    <>
      <DashboardHeading />
      <DriverProfileOverview 
            statsData={fetchStatsData}
            isLoading={statsDataLoading || fetchingDashboard}
      />
    </>
  );
};
